import { ServiceBase } from '../../../core/services/ServiceBase'
import DashboardProxy from './proxy'

const slidingExpireTimeInMinute = 60 * 24 // 1 day

class DashboardService extends ServiceBase {
  getNewsFeatured(params) {
    return this.getData(() => DashboardProxy.getNewsFeatured(params))
  }
  getNewsAndEvents(params) {
    return this.getData(() => DashboardProxy.getNewsAndEvents(params))
  }
  getReports(params) {
    return this.getData(() => DashboardProxy.getReports(params))
  }
  getMostPopular(params) {
    return this.getData(() => DashboardProxy.getMostPopular(params))
  }
  getRecentlyViewed(params) {
    return this.getData(() => DashboardProxy.getRecentlyViewed(params))
  }
  getVSIC(params) {
    return this.applyMemoryCache(
      'CategoryService.getVsic', // Same key in CategoryService
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => DashboardProxy.getVSIC(params))
  }
  getRiskDistribution(params) {
    return this.getData(() => DashboardProxy.getRiskDistribution(params))
  }
  getSuggestionCompany(params) {
    return this.getData(() => DashboardProxy.getSuggestionCompany(params))
  }
  getSuggestionCompanyDetail(params) {
    return this.getData(() => DashboardProxy.getSuggestionCompanyDetail(params))
  }
  getSavedPortfolio(params) {
    return this.getData(() => DashboardProxy.getSavedPortfolio(params))
  }
  getCreditRiskScore(params) {
    return this.getData(() => DashboardProxy.getCreditRiskScore(params))
  }
  getPerformanceScore(params) {
    return this.getData(() => DashboardProxy.getPerformanceScore(params))
  }
  getTotalAlert(params) {
    return this.getData(() => DashboardProxy.getTotalAlert(params))
  }
  getCurrentPlan(params) {
    return this.getData(() => DashboardProxy.getCurrentPlan(params))
  }
  getUserPricingPackages() {
    return this.getData(() => DashboardProxy.getUserPricingPackages())
  }
  getTrialList(params) {
    return this.getData(() => DashboardProxy.getTrialList(params))
  }
  checkRequestConnectMap(params) {
    return this.getData(() => DashboardProxy.checkRequestConnectMap(params))
  }
}

export default new DashboardService()
